import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center h-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_3 = { class: "my-4 text" }
const _hoisted_4 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingButton = _resolveComponent("LoadingButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.helperText), 1),
    _createVNode(_component_LoadingButton, {
      loading: _ctx.loading,
      disabled: !_ctx.teamsConnected,
      onClick: _ctx.routeToDashboard
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
      ]),
      _: 1
    }, 8, ["loading", "disabled", "onClick"]),
    (_ctx.responseError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.responseError.message), 1))
      : _createCommentVNode("", true),
    _hoisted_5
  ]))
}